/* EZMA app scripts: account drawer, search overlay, enhancements, review-markup cleanup */
  (function(){
    var drawer  = document.getElementById('accountDrawer');
    var overlay = document.getElementById('accountDrawerOverlay');
    var closeBtn = document.getElementById('accountDrawerClose');

    function openDrawer() {
      drawer.style.right = '0';
      overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.style.right = '-100%';
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    var toggle = document.getElementById('accountToggle');
    if (toggle) toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

    // Open on register tab if URL has #register
    if (window.location.hash === '#register') {
      openDrawer();
      window.switchTab && window.switchTab('register');
    }
  })();

  function switchTab(tab) {
    var loginTab    = document.getElementById('tabLogin');
    var registerTab = document.getElementById('tabRegister');
    var loginBtn    = document.getElementById('tabLoginBtn');
    var registerBtn = document.getElementById('tabRegisterBtn');
    if (!loginTab) return;
    if (tab === 'register') {
      loginTab.style.display    = 'none';
      registerTab.style.display = 'block';
      loginBtn.style.borderBottomColor    = 'transparent';
      loginBtn.style.color                = 'var(--text-muted)';
      registerBtn.style.borderBottomColor = 'var(--emerald-dark)';
      registerBtn.style.color             = 'var(--emerald-dark)';
    } else {
      registerTab.style.display = 'none';
      loginTab.style.display    = 'block';
      loginBtn.style.borderBottomColor    = 'var(--emerald-dark)';
      loginBtn.style.color                = 'var(--emerald-dark)';
      registerBtn.style.borderBottomColor = 'transparent';
      registerBtn.style.color             = 'var(--text-muted)';
    }
  }
  

  (function(){
    var overlay  = document.getElementById('searchOverlay');
    var closeBtn = document.getElementById('searchClose');
    var input    = document.getElementById('searchInput');
    var results  = document.getElementById('searchResults');
    var empty    = document.getElementById('searchEmpty');
    var hint     = document.getElementById('searchHint');
    var toggle   = document.getElementById('searchToggle');
    var timer;
    // Locale root ("/" on English, "/ms/" on Malay). Set in layout/theme.liquid; English-safe fallback.
    var ezRoot = window.EZMA_ROOT || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (ezRoot.charAt(ezRoot.length - 1) !== '/') ezRoot += '/';
    // /search/suggest.json only works unprefixed (the /ms/ variant answers 417 "Unsupported buyer locale")
    // and returns /products/... URLs, so internal result URLs get the locale root added.
    function ezLocal(u) {
      if (ezRoot === '/' || typeof u !== 'string' || u.charAt(0) !== '/' || u.charAt(1) === '/') return u;
      return (u + '/').indexOf(ezRoot) === 0 ? u : ezRoot + u.slice(1);
    }

    function openSearch() {
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      setTimeout(function(){ input.focus(); }, 80);
    }
    function closeSearch() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      input.value = '';
      results.style.display = 'none';
      empty.style.display   = 'none';
      hint.style.display    = 'block';
      results.innerHTML     = '';
    }

    if (toggle) toggle.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    overlay.addEventListener('click', function(e){
      if (e.target === overlay) closeSearch();
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeSearch();
    });

    function renderResults(items) {
      if (!items.length) {
        results.style.display = 'none';
        empty.style.display   = 'block';
        hint.style.display    = 'none';
        return;
      }
      empty.style.display = 'none';
      hint.style.display  = 'none';
      results.style.display = 'block';

      results.innerHTML = items.map(function(p) {
        var img   = p.featured_image ? p.featured_image.url + '&width=100' : '';
        // /search/suggest.json returns price_min as a decimal string ("39.90"),
        // not cents — dividing by 100 printed RM 0.40 for a RM 39.90 perfume.
        var ezRaw = p.price_min;
        var ezNum = typeof ezRaw === 'string' ? parseFloat(ezRaw.replace(/[^0-9.]/g, '')) : ezRaw / 100;
        var price = ezRaw && !isNaN(ezNum)
          ? 'RM ' + ezNum.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          : '';
        return [
          '<a href="' + ezLocal(p.url) + '" onclick="closeSearch && closeSearch()" style="',
            'display:flex; align-items:center; gap:16px; padding:16px 20px;',
            'text-decoration:none; color:inherit; border-bottom:1px solid rgba(0,0,0,0.06);',
            'transition:background 0.15s;',
          '" onmouseover="this.style.background=\'#f9f6f1\'" onmouseout="this.style.background=\'\'">',
            img ? '<img src="' + img + '" style="width:60px;height:60px;object-fit:cover;border-radius:10px;flex-shrink:0;">' : '',
            '<div style="flex:1; min-width:0;">',
              '<p style="margin:0 0 4px;font-family:var(--font-heading);font-size:1rem;color:var(--emerald-dark);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + p.title + '</p>',
              p.product_type ? '<p style="margin:0 0 4px;font-size:0.75rem;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.1em;">' + p.product_type + '</p>' : '',
              price ? '<p style="margin:0;font-size:0.9rem;font-weight:700;color:var(--emerald-mid);">' + price + '</p>' : '',
            '</div>',
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0F5C3E" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>',
          '</a>'
        ].join('');
      }).join('') +
      '<a href="' + ezRoot + 'search?q=' + encodeURIComponent(input.value) + '" style="display:block;padding:14px 20px;text-align:center;font-family:var(--font-body);font-size:0.82rem;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:var(--emerald-mid);text-decoration:none;border-top:1px solid rgba(0,0,0,0.06);">' + ((window.EZMA_I18N && window.EZMA_I18N.view_all_results) || 'View all results →') + '</a>';
    }

    function doSearch(q) {
      if (q.length < 2) {
        results.style.display = 'none';
        empty.style.display   = 'none';
        hint.style.display    = 'block';
        return;
      }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function(r){ return r.json(); })
        .then(function(data){
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(items);
        })
        .catch(function(){
          results.style.display = 'none';
          empty.style.display   = 'block';
        });
    }

    input.addEventListener('input', function(){
      clearTimeout(timer);
      timer = setTimeout(function(){ doSearch(input.value.trim()); }, 220);
    });

    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = ezRoot + 'search?q=' + encodeURIComponent(input.value.trim());
      }
    });
  })();
  

(function(){'use strict';
  var ann=document.getElementById('shopify-section-announcement-bar');
  var h=document.getElementById('siteHeader');
  if(h){
    function measure(){
      var a=(ann&&getComputedStyle(ann).display!=='none')?ann.offsetHeight:0;
      var hh=h.offsetHeight;
      document.body.style.setProperty('--ez-htop',a+'px');
      document.body.style.setProperty('--ez-pad',(a+hh)+'px');
      document.body.style.setProperty('--ez-annhide','-'+(a+10)+'px');
      document.body.style.setProperty('--ez-hide','-'+(a+hh+10)+'px');
    }
    measure();window.addEventListener('resize',measure);
    var cb=document.getElementById('announcementClose');
    if(cb)cb.addEventListener('click',function(){setTimeout(measure,60);});
    var last=window.pageYOffset||0,t=false;
    function s(){var y=window.pageYOffset||document.documentElement.scrollTop||0;
      if(y<=80)document.body.classList.remove('ez-hide');
      else if(y>last+6)document.body.classList.add('ez-hide');
      else if(y<last-6)document.body.classList.remove('ez-hide');
      last=y;t=false;}
    window.addEventListener('scroll',function(){if(!t){requestAnimationFrame(s);t=true;}},{passive:true});
  }
  (function(){var TH=2,items=document.getElementById('cartItems');if(!items)return;
    var host=items.parentNode,bar=document.createElement('div');bar.className='ezma-ship-bar';
    bar.innerHTML='<p class="ezma-ship-bar__msg"></p><div class="ezma-ship-bar__track"><div class="ezma-ship-bar__fill"></div></div>';
    host.insertBefore(bar,items);var msg=bar.querySelector('.ezma-ship-bar__msg'),fill=bar.querySelector('.ezma-ship-bar__fill');
    function r(c){var p=Math.min(100,Math.round(c/TH*100));fill.style.width=p+'%';
      if(c>=TH){bar.classList.add('ezma-ship-bar--done');msg.innerHTML=(window.EZMA_I18N&&window.EZMA_I18N.ship_done)||'🎉 You’ve unlocked <b>FREE shipping</b>!';}
      else{bar.classList.remove('ezma-ship-bar--done');var n=TH-c;msg.innerHTML=(window.EZMA_I18N&&window.EZMA_I18N.ship_more)?window.EZMA_I18N.ship_more.replace('{n}',n):'Add <b>'+n+' more item'+(n>1?'s':'')+'</b> for <b>FREE shipping</b> 🚚';}
      bar.style.display=c>0?'block':'none';}
    function f(){fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(x){return x.json();}).then(function(c){r(c.item_count||0);}).catch(function(){});}
    f();document.addEventListener('click',function(e){if(e.target.closest('[data-cart-open],[data-add-to-cart],.qty-btn,.cart-item__remove'))setTimeout(f,600);});
    new MutationObserver(f).observe(items,{childList:true,subtree:true});})();
})();


(function(){
  function strip(){
    document.querySelectorAll('.jdgm-rich-snippet[itemtype],.jdgm-prev-badge [itemtype],.jdgm-widget [itemtype]').forEach(function(e){e.removeAttribute('itemscope');e.removeAttribute('itemtype');e.removeAttribute('itemprop');});
    document.querySelectorAll('.jdgm-rich-snippet [itemprop],.jdgm-prev-badge [itemprop]').forEach(function(e){e.removeAttribute('itemprop');});
  }
  strip();document.addEventListener('DOMContentLoaded',strip);
  setTimeout(strip,1500);setTimeout(strip,3500);
  try{new MutationObserver(strip).observe(document.documentElement,{childList:true,subtree:true});}catch(e){}
})();


/* ── currency label: RM, not MYR (27 Sep 2026) ───────────────────────
   Malaysian shoppers read "RM"; "MYR" is the ISO banking code. Product
   pages, collection cards and the search list all print RM, but the cart
   drawer built its prices with ezMoney() in assets/theme.js, which hard
   coded "MYR " — so the same product changed currency symbol between the
   page and the drawer. ezMoney is a top-level function declaration, and
   this file is deferred after theme.js, so replacing the global here is
   picked up by renderCartDrawer() and ezCartPending() on every render.
   Fixing it inside theme.js itself is the tidier home for it; that file
   is minified and was not safe to rewrite by hand, so it lives here.
   ──────────────────────────────────────────────────────────── */
(function(){
  if(typeof window.ezMoney!=='function')return;
  window.ezMoney=function(cents){
    return 'RM '+(cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  };
})();
